import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerActKC2SmrTotalsGql } from '../../workOrderQueries';

const requestId = 'uerActKC2SmrTotals';

export const useUerActKC2SmrTotals = (actKC2Id?: number, getActKC2TotalOnly?: boolean) => {
    const [uerActKC2SmrTotalsReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => {
        const where = getActKC2TotalOnly
            ? {
                  isActKC2Total: { eq: true },
              }
            : undefined;

        return { actKC2Id, where };
    }, [actKC2Id, getActKC2TotalOnly]);

    const [uerActKC2SmrTotalsData, uerActKC2SmrTotalsStatus] = useRequest({
        requestId,
        query: uerActKC2SmrTotalsGql,
        variables,
        withEffect: !!actKC2Id,
    });

    useEffect(() => {
        uerActKC2SmrTotalsReset(undefined);
    }, [uerActKC2SmrTotalsReset]);

    const items = useMemo(
        () => uerActKC2SmrTotalsData?.uerActKC2SmrTotals?.items || [],
        [uerActKC2SmrTotalsData?.uerActKC2SmrTotals?.items],
    );

    return {
        items,
        status: uerActKC2SmrTotalsStatus,
    };
};
